import { ActionTree } from "vuex";
import { AuthState } from "./state";

export const actions: ActionTree<AuthState, any> = {
  async login({ commit }, { email, password }) {
    const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
    const response = await fetch(`${apiUrl}/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Login failed");
    }

    const user = {
      ...data.user,
      permissions: data.permissions,
    };

    commit("SET_USER", user);
    commit("SET_TOKEN", data.accessToken);

    return true;
  },
  logout({ commit }) {
    commit("LOGOUT");
  },
};
